"use client";

import { useLayoutEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

/** Wide enough for the sticky panel (docs.css hides it at 1100px and below). */
const WIDE = "(min-width: 1101px)";

/**
 * Code a page renders once (T13e-2b): under its words, as a phone, a tablet and a page with no script see it;
 * on a wide screen, moved into its frame of the sticky panel. A reference page with a route's code in five
 * languages would otherwise carry every window twice.
 */
export function Docked({
  frame,
  children,
}: {
  frame: string;
  children: ReactNode;
}) {
  const [dock, setDock] = useState<Element | null>(null);
  // Before the paint: code that arrives later (a route's fields fetched) never shows inline for a frame first.
  useLayoutEffect(() => {
    const wide = window.matchMedia?.(WIDE);
    const place = () =>
      setDock(
        wide?.matches
          ? document.querySelector(`.rail .frame[data-k="${frame}"]`)
          : null
      );
    place();
    wide?.addEventListener("change", place);
    return () => wide?.removeEventListener("change", place);
  }, [frame]);
  if (dock) return createPortal(children, dock);
  return (
    <div className="inline">
      <div className="win">
        <div className="frame on">{children}</div>
      </div>
    </div>
  );
}
